import React, { Component } from 'react'
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Protected from './protected/Protected'


//Layout
import Layout from './components/Layout/Layout'

//Notification
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'

//pages 
import Login from './pages/Login/Login'
import NotFound from './pages/NotFound/NotFound'

class App extends Component {
  render() {
    return (
      <div>
             <ReactNotification />
         <BrowserRouter>
                <Switch>

                   <Route path="/" exact render={() => <Redirect to="/app/main"/>}/>
                    <Route path="/app" exact render={() => <Redirect to="/app/main"/>}/>
                    <Protected path="/app" component={Layout}/>
                    <Route path="/login" exact component={Login}/>
                    <Route component={NotFound} />
                </Switch>
          </BrowserRouter>
      </div>
    )
  }
}

export default App
